$(() => {
    const pageURL = window.location.href.toLowerCase()
  /*
   * Add body class to determine seatmap background
   */

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true }

  // Callback function to execute when mutations are observed
  const callback = function (mutationsList, observer) {
    // Use traditional 'for loops' for IE 11

    const $body = $('body')

    for (const mutation of mutationsList) {
      // Check for seat ID within each seatmap layout
      if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"2609545\"]") && mutation.type === "childList") {
          // If so then add body class, and remove other body classes
          // Sadler's Wells Theatre
          $body.addClass('seatmap--sadlers-stalls');
          $body.removeClass('seatmap--sadlers-first-circle seatmap--sadlers-second-circle');
      } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"2611624\"]") && mutation.type === "childList") {
          $body.addClass('seatmap--sadlers-first-circle');
          $body.removeClass('seatmap--sadlers-stalls seatmap--sadlers-second-circle');
      } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"2614182\"]") && mutation.type === "childList") {
          $body.addClass('seatmap--sadlers-second-circle');
          $body.removeClass('seatmap--sadlers-stalls seatmap--sadlers-first-circle');
      } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"2617634\"]") && mutation.type === "childList") {
          // Peacock
          $body.addClass('seatmap--peacock-stalls');
          $body.removeClass('seatmap--peacock-dress-circle');
      } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"2619474\"]") && mutation.type === "childList") {
          $body.addClass('seatmap--peacock-dress-circle');
          $body.removeClass('seatmap--peacock-stalls');
      } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"2667053\"]") && mutation.type === "childList") {
         // Stratford Waterfront Theatre
          $body.addClass('seatmap--stratford-waterfront');
      }
    }
  }

  function addObserverIfDesiredNodeAvailable () {
    const targetNode = document.querySelector('.tn-syos')
    if (!targetNode) {
      // The node we need does not exist yet.
      // Wait 500ms and try again
      window.setTimeout(addObserverIfDesiredNodeAvailable, 500)
      return
    }
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback)

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config)
  }
  addObserverIfDesiredNodeAvailable()
})
